import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

export type KambiCouponBetStatus = 'Won' | 'Pending' | 'No Payout' | 'Refunded' | null

export function getKambiCouponBetStatus(
  betStatus?:
    | KambiHistoryCoupon['bets'][0]['betStatus']
    | KambiHistoryCoupon['couponRows'][0]['status']
): KambiCouponBetStatus {
  if (!betStatus) return null

  switch (betStatus) {
    case 'WON':
    case 'CASHED_OUT':
    case 'CLAIMED':
      return 'Won'
    case 'VOID':
    case 'CANCELLED':
      return 'Refunded'
    case 'LOST':
    case 'REJECTED':
    case 'REJECTED_BY_AAMS':
    case 'EXPIRED':
      return 'No Payout'
    case 'OPEN':
    case 'PLACED':
    case 'WAITING_FOR_APPROVAL':
    case 'WAITING_FOR_APPROVAL_BY_AAMS':
    default:
      return 'Pending'
  }
}
